export * from './WindowControls';
export { default } from './WindowControls';
